'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Search = exports.ENGAGEMENT_ELEMENTS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _tracking = require('@spp/tracking');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _index = require('../svg/index');

var _index2 = require('../props/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* global window */
var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    SEARCH: 'Masthead_Search'
};

var Search = exports.Search = function (_Component) {
    (0, _inherits3.default)(Search, _Component);

    function Search(props) {
        (0, _classCallCheck3.default)(this, Search);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call(this, props));

        _this.onSearchPhraseSubmitted = function (event) {
            event.preventDefault();

            var _this$props = _this.props,
                searchUrl = _this$props.searchUrl,
                engagement = _this$props.engagement;
            var phrase = _this.state.phrase;


            var url = searchUrl.replace('{query}', phrase);

            _tracking.util.actionThenRelocateWithTimeout(engagement({
                elementIdentifier: ENGAGEMENT_ELEMENTS.SEARCH,
                meta: {
                    name: 'Search',
                    event: event
                }
            }), url);

            _this.props.onSearchPhraseSubmitted(url);
        };

        _this.onClearSearchPhrase = function (event) {
            event.preventDefault();

            _this.setState({
                phrase: ''
            });
        };

        _this.setWrapperRef = function (node) {
            _this.wrapperRef = node;
        };

        _this.handleClickOutside = function (event) {
            if (_this.state.formOpened && _this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
                _this.closeSearchField();
            }
        };

        _this.closeSearchField = function () {
            _this.setState({
                formOpened: false
            });
        };

        _this.toggleSearchField = function () {
            _this.setState(function (prevState) {
                return {
                    formOpened: !prevState.formOpened
                };
            });
        };

        _this.handleChange = function (event) {
            _this.setState({
                phrase: event.target.value
            });
        };

        _this.renderSearchClearButton = function (_ref) {
            var theme = _ref.theme,
                searchClearSvg = _ref.searchClearSvg;
            return _react2.default.createElement(
                'button',
                { className: theme.clearButton, onClick: _this.onClearSearchPhrase, type: 'button' },
                _react2.default.createElement(_index.SearchClearSvg, { icon: searchClearSvg, title: searchClearSvg.title })
            );
        };

        _this.renderForm = function (_ref2) {
            var theme = _ref2.theme,
                searchPlaceholderLabel = _ref2.searchPlaceholderLabel,
                searchSvg = _ref2.searchSvg,
                searchClearSvg = _ref2.searchClearSvg;
            return _react2.default.createElement(
                'div',
                { className: theme.formContainer },
                _react2.default.createElement(
                    'form',
                    { className: theme.form, onSubmit: _this.onSearchPhraseSubmitted },
                    _react2.default.createElement(_index.SearchSvg, { icon: searchSvg, title: searchSvg.title }),
                    _react2.default.createElement('label', { htmlFor: 'searchInput' }),
                    _react2.default.createElement('input', {
                        type: 'search',
                        autoComplete: 'off',
                        id: 'searchInput',
                        onChange: _this.handleChange,
                        value: _this.state.phrase,
                        placeholder: searchPlaceholderLabel,
                        'aria-label': searchPlaceholderLabel,
                        className: theme.searchInput
                    }),
                    _react2.default.createElement(
                        'button',
                        { className: theme.formSubmit, type: 'submit', 'aria-label': 'Submit' },
                        _react2.default.createElement(_index.SearchSvg, { icon: searchSvg, title: searchSvg.title })
                    )
                ),
                _this.state.phrase ? _this.renderSearchClearButton({ theme: theme, searchClearSvg: searchClearSvg }) : null
            );
        };

        _this.renderIcon = function (_ref3) {
            var theme = _ref3.theme,
                searchSvg = _ref3.searchSvg,
                searchLabel = _ref3.searchLabel;
            return _react2.default.createElement(
                'button',
                { className: theme.showSearchButton, onClick: _this.toggleSearchField },
                _react2.default.createElement(
                    'span',
                    { className: theme.searchIconLabel },
                    searchLabel
                ),
                _react2.default.createElement(_index.SearchSvg, { icon: searchSvg, title: searchSvg.title })
            );
        };

        _this.state = {
            phrase: '',
            formOpened: false
        };

        _this.wrapperRef = null;
        return _this;
    }

    (0, _createClass3.default)(Search, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.document.addEventListener('mousedown', this.handleClickOutside);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.document.removeEventListener('mousedown', this.handleClickOutside);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                theme = _props.theme,
                searchLabel = _props.searchLabel,
                searchPlaceholderLabel = _props.searchPlaceholderLabel,
                searchSvg = _props.searchSvg,
                searchClearSvg = _props.searchClearSvg;


            var containerClasses = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.root, true), (0, _defineProperty3.default)(_classnames, theme.searchFormOpened, this.state.formOpened), _classnames));

            var formParams = { theme: theme, searchPlaceholderLabel: searchPlaceholderLabel, searchSvg: searchSvg, searchClearSvg: searchClearSvg };

            return _react2.default.createElement(
                'div',
                { className: containerClasses, ref: this.setWrapperRef },
                this.renderForm(formParams),
                this.renderIcon({ theme: theme, searchSvg: searchSvg, searchLabel: searchLabel })
            );
        }
    }]);
    return Search;
}(_react.Component);

if (process.env.NODE_ENV !== 'production') {
    Search.propTypes = {
        engagement: _propTypes2.default.func,
        searchLabel: _propTypes2.default.string.isRequired,
        searchPlaceholderLabel: _propTypes2.default.string.isRequired,
        searchSvg: _propTypes2.default.shape(_index2.svgProps).isRequired,
        searchClearSvg: _propTypes2.default.shape(_index2.svgProps).isRequired,
        searchUrl: _propTypes2.default.string.isRequired,
        onSearchPhraseSubmitted: _propTypes2.default.func.isRequired,
        theme: _propTypes2.default.shape({
            'cn-search-button': _propTypes2.default.string,
            'cn-masthead-label': _propTypes2.default.string
        })
    };
}

Search.defaultProps = {
    engagement: function engagement(props) {
        return props;
    },
    theme: {}
};

exports.default = Search;
//# sourceMappingURL=Search.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/Search/Search.js
 ** module id = 614
 ** module chunks = 1
 **/